import { ArrowLeft, Clock } from "lucide-react";
import { ArticleBody } from "../components/Blog";
import { PageShell } from "../components/PageShell";

export default function ArticlePage({ post, loading }) {
  if (loading && !post) {
    return <PageShell section="Notes"><main className="article-page article-page--loading"><div className="article-page__skeleton" /></main></PageShell>;
  }
  if (!post) {
    return <PageShell section="Notes"><main className="not-found-page"><h1>I could not find that note.</h1><a href="/notes"><ArrowLeft size={17} aria-hidden="true" /> Browse notes</a></main></PageShell>;
  }

  const tone = safeTone(post.visualTone);

  return (
    <PageShell section="Notes">
      <main className={`article-page article-page--${tone}`} id="main">
        <a className="page-back-link" href="/notes"><ArrowLeft size={16} aria-hidden="true" /> All notes</a>
        <article>
          <header className="article-masthead">
            <div className="article-masthead__copy">
              <p>{post.category || "Mental health"} <span><Clock size={15} aria-hidden="true" /> {post.readingTime || "4 min"}</span></p>
              <h1>{post.title}</h1>
              <p>{post.excerpt}</p>
            </div>
            {post.coverImage && <figure><img src={post.coverImage} alt={post.coverAlt || ""} width="1800" height="1126" fetchPriority="high" /></figure>}
          </header>
          <div className="article-reading-grid">
            <p className="article-reading-note">A note from Dr. Neerja’s learning desk. Read at your own pace and keep what helps the next conversation.</p>
            <div><ArticleBody body={post.body} /><aside className="article-disclaimer">I share this for education. It cannot diagnose a condition or replace advice from a qualified clinician who knows your situation.</aside></div>
          </div>
        </article>
      </main>
    </PageShell>
  );
}

function safeTone(value) {
  return ["sage", "plum", "peach", "dusk", "blue", "walnut", "terracotta", "sand", "amber"].includes(value) ? value : "sage";
}
